import requests from '../../api/client'
import { OtpApiResult, ValidateOtpOk, OtpError, HttpAnswer } from '../../types/otp'
import extractOtpMessage from './extractOtpMessage'

interface ValidateOtpParams {
  otp_session_token: string
  codigo: string
}

export default async function validateOtp(
  params: ValidateOtpParams
): Promise<OtpApiResult<ValidateOtpOk>> {
  const response = (await requests.otpValidate(params)) as HttpAnswer
  const status = response?.status ?? 200
  const data = response?.data ?? response

  if (status >= 200 && status < 300) {
    return { status, body: data as ValidateOtpOk }
  }

  const body: OtpError = {
    retorno: false,
    message: extractOtpMessage(data, 'Não foi possível validar o código.'),
  }
  return { status, body }
}